module.exports = __webpack_public_path__ + "img/03-CASACCA-ELBA-U--STAMPE-LINO-UNITI-LINO04.ac2cf15c.jpg";